import { resource, resourceFactory } from 'ember-resources';
import SocketRecordTable from './socket-record-table';

// Wraps a SocketRecordTable in a resource so it sets up/tears down with the
// component and rebuilds whenever a tracked value read in the options thunk
// changes. Replaces the did-insert/did-update/willDestroy lifecycle wiring.
//
// options() returns the SocketRecordTable constructor options, plus an optional
// afterStart(table) hook run once the initial fetch resolves — for tables that
// layer a second data source on top of the seed fetch.
export const socketRecordTable = resourceFactory((options) =>
	resource(({ on }) =>
	{
		const { afterStart, ...tableOptions } = options();
		const table = new SocketRecordTable(tableOptions);
		on.cleanup(() => table.teardown());
		const started = table.start();
		if(afterStart)
		{
			started.then(() => afterStart(table));
		}
		return table;
	})
);

// Also exported as default so the addon's auto-generated app-js re-export stub
// (which re-exports `default`) resolves without a build warning. Prefer the
// named `socketRecordTable` import.
export default socketRecordTable;
